import $ from 'jquery';

/**
 * 
 */
export default class SearchButtons {

	/**
	 * [constructor description]
	 * @param  {[type]} options [description]
	 * @return {[type]}         [description]
	 */
	constructor(options) {
		this.panel = options.panel;
		// @todo move to init method
		this.buttons = Array.prototype.slice.call(document.getElementsByClassName(options.className));
		this.listeners = this.initListeners();
	}

	/**
	 *
			// on nav slide in, change depth
			// 
			// on search slide down, delay hide
			// 
			// 
	 */
	initListeners() {
		window.uo.events.addListener('menu--open', this.onNavOpen.bind(this));
		window.uo.events.addListener('menu--close', this.onNavClose.bind(this));
		window.uo.events.addListener('search-panel--open', this.onSearchPanelOpen.bind(this));
		window.uo.events.addListener('search-panel--close', this.onSearchPanelClose.bind(this));
		return this.buttons.map((button) => {button.addEventListener('click', this.onClick.bind(this))});
	}



	/**
	 * launches or hides the panel based on the panel property
	 * @chainable
	 */
	onClick(event) {
		if ($('html').scrollTop() !== 0) {
			$('html').animate({scrollTop: 0}, 100);
		}

		event.preventDefault();
		!this.panel.isActive ? this.panel.launch() : this.panel.hide();
		return this;
	}

	onNavOpen() {
		this.buttons.forEach((button) => {
			button.style.zIndex = 1;
		});
	}

	onNavClose() {
		(function(self) {
			setTimeout(function() {
				self.buttons.forEach((button) => {
					button.style.zIndex = 1000;
				});

			}, 500);
		})(this);
		
	}

	onSearchPanelOpen() {

		$('.header__search-button').children('span').fadeOut(200);
		(function(self) {

			$( '.toggle-search-button' ).addClass( 'active' );

			setTimeout(function() {
				$('.header__search-button').children('span').removeClass('uo-icon-search').addClass('uo-icon-close');
			}, 200);

			setTimeout(function() {
				$('.header__search-button').children('span').fadeIn(400);
			}, 300);

		})(this);

		$( '#search' ).focus();
	}

	onSearchPanelClose() {
		$( '.toggle-search-button' ).removeClass( 'active' );
		$('.header__search-button').children('span').removeClass('uo-icon-close').addClass('uo-icon-search');
	}

}